import api from 'api'

export type CreateCushionChargePolicyRequest = {
  companyId: number
  chargeAfterMinutes: number
  startsAt: string
}

export type CreateCushionChargePolicyResponse = {
  id: number
}

export const createCushionChargePolicy = async ({
  companyId,
  ...body
}: CreateCushionChargePolicyRequest): Promise<CreateCushionChargePolicyResponse> => {
  const response = await api.post<CreateCushionChargePolicyResponse>(
    `/admin/company/${companyId}/cushion_charge_policies`,
    body
  )
  return response.data
}
